import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useTreeViewContext} from 'components/ContextMenu/hooks/useTreeViewContext';

export const ContextMenuWrapper = React.memo(
   ({
      data,
      className,
      children,
      parentRef,
   }: {
      data: INav;
      className?: string;
      children?: React.ReactNode;
      parentRef?: React.Ref<any>;
   }) => {
      const {handleClick} = useTreeViewContext();

      return (
         <div ref={parentRef} className={className} onContextMenu={handleClick(data)}>
            {children}
         </div>
      );
   }
);
